import useChartOptions from '@/components/Chart/hooks/options/useChartOptions';
import useSpotOptions from '@/components/Chart/hooks/options/useSpotOptions';
import RegularChart from '@/components/Chart/RegularChart';
import { generateMockSeries } from '@/pages/DataHub/mock/chartSeries.mock';

const mockData = [generateMockSeries()];

const UnauthenticatedChart = () => {
  const { createOptions } = useSpotOptions(14);
  const { options: chartOptions } = useChartOptions(mockData, createOptions);
  return (
    <RegularChart
      chartSeries={mockData}
      error={false}
      height={14}
      loading={false}
      options={chartOptions}
      showLegend={false}
    />
  );
};
export default UnauthenticatedChart;
